(() => {
  'use strict';
  if (window.pnmCollectionConfidenceReady) return;
  const node = document.querySelector('[data-pnm-confidence-config]');
  if (!node) return;
  window.pnmCollectionConfidenceReady = true;
  const labels = JSON.parse(node.textContent);
  const excluded = new Set(['705339', '705340', '705341', '705342', '852962', 'select-your-model']);
  const cardSelector = '.product-card.pnm-card[data-product-card]';
  const storageKey = 'pnm_collection_return_v1';

  // Only explicit selling statements and pack notation in the listing are evidence.
  // Do not infer quantities from photos, fitment, model numbers, or kit components.
  function saleUnit(title, lines) {
    const evidence = [];
    const clean = text => text.replace(/\s+/g, ' ').trim().replace(/[.!]$/, '');
    function counted(text) {
      const pattern = /\b(pk|pack|set)\s*(?:\/|of\s+)([1-9]\d{0,2})(?![\d.]|[-\s]*(?:mm|cm|inch|inches|cyl|cylinder|cylinders|stroke)\b)\b/gi;
      return [...text.matchAll(pattern)].map(match => ({ kind: match[1].toLowerCase() === 'set' ? 'set' : 'pack', count: Number(match[2]) }));
    }
    evidence.push(...counted(title));
    for (const raw of lines) {
      const text = clean(raw);
      if (/^sold (?:individually|separately|each|singly)$/i.test(text)) evidence.push({ kind: 'each', count: 1 });
      else if (/^sold (?:as (?:a )?pair|in pairs)$/i.test(text)) evidence.push({ kind: 'pair', count: 2 });
      else if (/^sold as (?:a )?(set|kit)$/i.test(text)) evidence.push({ kind: /kit$/i.test(text) ? 'kit' : 'set', count: null });
      else if (/^sold (?:as (?:a )?|in (?:a )?)(?:set|pack) of [1-9]\d{0,2}$/i.test(text)) evidence.push(...counted(text));
      else if (/^pack quantity\s*:\s*[1-9]\d{0,2}$/i.test(text)) evidence.push({ kind: 'pack', count: Number(text.split(':')[1].trim()) });
      else if (/\bsold\b/i.test(text)) return '';
    }
    if (!evidence.length) return '';
    const counts = [...new Set(evidence.map(item => item.count).filter(count => count !== null))];
    if (counts.length > 1) return '';
    const kinds = new Set(evidence.map(item => item.kind));
    if ((kinds.has('each') && kinds.size > 1) || (kinds.has('kit') && kinds.size > 1)) return '';
    if (counts.length) {
      const count = counts[0];
      if (kinds.has('each')) return labels.each;
      if (kinds.has('pair') && count === 2) return labels.pair;
      return (kinds.has('set') ? labels.setCount : labels.pack).replace('__count__', String(count));
    }
    return kinds.size === 1 ? labels[evidence[0].kind] : '';
  }

  function collectionKey(href) {
    const url = new URL(href, location.origin);
    url.hash = '';
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('_fd');
    url.searchParams.delete('pb');
    url.searchParams.sort();
    return url.pathname + url.search;
  }
  function recoveryURL(href, kind, filterIds, searchName) {
    const url = new URL(href, location.origin);
    if (kind === 'search') {
      // Native collection search names only; never remove the bike's gff_ fields.
      ['q', 'query', 'search', ...(searchName && !/^gff?_/.test(searchName) ? [searchName] : [])].forEach(key => url.searchParams.delete(key));
    } else {
      filterIds.filter(id => !excluded.has(id)).forEach(id => url.searchParams.delete('gf_' + id));
    }
    url.searchParams.delete('page');
    url.hash = 'gf-controls-container';
    return url.pathname + url.search + url.hash;
  }
  const root = () => document.querySelector('#gf-grid');
  const products = () => document.querySelector('#gf-products');
  const controls = () => document.querySelector('#gf-controls-container');
  const cards = () => [...document.querySelectorAll('#gf-products ' + cardSelector)];
  const filters = () => [...document.querySelectorAll('#gf-tree [data-filter-id]')].filter(block => !excluded.has(block.dataset.filterId));
  const searchInput = () => document.querySelector('.gf-controls-search-form input:not([type="hidden"]):not([type="submit"]):not([type="button"])');
  let busy = false, timeout = 0, settleTimer = 0, queued = false;
  let observedGrid = null, snapshot = [], lastHeight = 0, announcement;
  let restoration = null, restoreTimeout = 0, oldScrollMode = null;

  function enhanceUnits() {
    document.querySelectorAll(':is(#gf-grid,#collection-page) ' + cardSelector).forEach(card => {
      const source = card.querySelector('template[data-pnm-pack-source]');
      const price = card.querySelector('.product-price[data-price]');
      if (!source || !price) return;
      const statements = [...source.content.querySelectorAll('span')].map(line => line.textContent);
      const text = saleUnit(source.dataset.title || '', statements);
      let unit = price.querySelector('.pnm-card-unit');
      if (!text) { unit?.remove(); return; }
      if (!unit) { unit = document.createElement('span'); unit.className = 'pnm-card-unit'; price.append(unit); }
      if (unit.textContent !== text) unit.textContent = text;
    });
  }
  function message(text) {
    if (announcement && announcement.textContent !== text) announcement.textContent = text;
  }
  function loadingPanel() {
    const grid = root();
    if (!grid) return null;
    let panel = grid.querySelector(':scope > .pnm-results-state');
    if (!panel) {
      panel = document.createElement('div'); panel.className = 'pnm-results-state';
      const spinner = document.createElement('span'); spinner.className = 'pnm-results-state__spinner'; spinner.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span'); copy.className = 'pnm-results-state__copy';
      const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = labels.retry; retry.hidden = true;
      retry.addEventListener('click', () => location.reload());
      panel.append(spinner, copy, retry); grid.append(panel);
    }
    return panel;
  }
  function applyBusy() {
    const grid = root(), list = products();
    if (!grid || !busy) return;
    grid.classList.add('pnm-results-busy');
    grid.setAttribute('aria-busy', 'true');
    controls()?.classList.add('pnm-count-pending');
    if (list) {
      list.style.setProperty('--pnm-results-height', Math.max(260, lastHeight) + 'px'); list.inert = true;
      grid.style.setProperty('--pnm-loading-top', Math.max(0, list.getBoundingClientRect().top - grid.getBoundingClientRect().top) + 'px');
    }
    const panel = loadingPanel();
    if (panel && panel.dataset.error !== 'true') panel.querySelector('.pnm-results-state__copy').textContent = labels.loading;
  }
  function begin() {
    const list = products();
    if (!busy) lastHeight = list?.getBoundingClientRect().height || lastHeight;
    busy = true; snapshot = cards();
    clearTimeout(settleTimer); clearTimeout(timeout);
    const panel = loadingPanel();
    if (panel) { panel.dataset.error = 'false'; panel.querySelector('button').hidden = true; }
    document.querySelector('.pnm-empty-results')?.remove();
    applyBusy(); message(labels.loading);
    timeout = setTimeout(() => {
      // A stalled request must not display old products under new filter context.
      if (!busy) return;
      const current = loadingPanel();
      if (current) {
        current.dataset.error = 'true';
        current.querySelector('.pnm-results-state__copy').textContent = labels.loadError;
        current.querySelector('button').hidden = false;
      }
      message(labels.loadError);
    }, 20000);
  }
  function finish() {
    clearTimeout(timeout); clearTimeout(settleTimer);
    enhanceUnits();
    busy = false;
    const panel = loadingPanel();
    if (panel) {
      panel.dataset.error = 'false';
      panel.querySelector('button').hidden = true;
      panel.querySelector('.pnm-results-state__copy').textContent = labels.ready;
    }
    root()?.classList.remove('pnm-results-busy');
    root()?.setAttribute('aria-busy', 'false');
    controls()?.classList.remove('pnm-count-pending');
    const list = products();
    if (list) { list.inert = false; list.style.removeProperty('--pnm-results-height'); lastHeight = list.getBoundingClientRect().height; }
    syncEmpty();
    message(labels.ready);
    restorePosition();
  }
  function settle() {
    clearTimeout(settleTimer);
    clearTimeout(timeout);
    settleTimer = setTimeout(finish, 180);
  }
  function confirmedEmpty() {
    if (!products() || cards().length) return false;
    const summary = controls()?.querySelector('.gf-summary');
    const number = summary?.querySelector('b,strong')?.textContent.trim() || summary?.textContent.match(/\d[\d,.]*/)?.[0];
    return number === '0';
  }
  function syncEmpty() {
    let panel = document.querySelector('.pnm-empty-results');
    if (busy || !confirmedEmpty()) { panel?.remove(); return; }
    const input = searchInput();
    const filterIds = filters().map(block => block.dataset.filterId);
    const params = new URLSearchParams(location.search);
    const hasSearch = Boolean(input?.value.trim() || ['q', 'query', 'search'].some(key => params.get(key)));
    const hasFilters = filterIds.some(id => params.has('gf_' + id)) || filters().some(block => block.querySelector('[aria-checked="true"]'));
    const browse = window.PNMBikeBrowse?.context();
    const bike = browse?.bike || window.PNMCollectionYear?.context()?.bike;
    const category = document.querySelector('[data-pnm-main-categories]')?.dataset.activeCategory || '';
    const categoryEmpty = bike && category && !hasSearch && !hasFilters;
    const bikeText = bike?.bikeYear ? [bike.bikeYear, bike.brand, bike.modelDisplay || bike.modelType].filter(Boolean).join(' ') : '';
    const signature = JSON.stringify([location.href, hasSearch, hasFilters, bikeText]);
    if (panel?.dataset.signature === signature) return;
    if (!panel) { panel = document.createElement('section'); panel.className = 'pnm-empty-results'; products().after(panel); }
    panel.dataset.signature = signature; panel.replaceChildren();
    const heading = document.createElement('h2'); heading.textContent = categoryEmpty ? labels.emptyCategory.replace('[category]',category).replace('[bike]',bikeText) : labels.emptyTitle;
    panel.append(heading);
    if (bikeText) { const bikeLine = document.createElement('p'); bikeLine.textContent = labels.emptyBike.replace('__bike__', bikeText); panel.append(bikeLine); }
    const help = document.createElement('p'); help.textContent = categoryEmpty ? labels.emptyCategoryNote : bikeText ? labels.emptyHelp : labels.emptyGeneric; panel.append(help);
    const actions = document.createElement('div'); actions.className = 'pnm-empty-actions';
    if (hasSearch) { const link = document.createElement('a'); link.textContent = labels.clearSearch; link.href = recoveryURL(location.href, 'search', filterIds, input?.name); actions.append(link); }
    if (hasFilters) { const link = document.createElement('a'); link.textContent = labels.clearCategories; link.href = recoveryURL(location.href, 'category', filterIds); actions.append(link); }
    const contact = document.createElement('a'); contact.textContent = labels.contact; contact.href = window.PNMEasyShopping?.contactURL(category) || labels.contactURL; contact.className = 'pnm-empty-contact'; actions.append(contact);
    const allURL = window.PNMEasyShopping?.allPartsURL();
    if (allURL) { const all = document.createElement('a'); all.href = allURL; all.textContent = labels.allParts; actions.prepend(all); }
    panel.append(actions);
    if (categoryEmpty && window.PNMEasyShopping) {
      const source = document.querySelector('[data-pnm-main-categories] a[aria-current="page"][data-category]');
      if (source) {
        const target = new URL(source.dataset.pnmCategoryBase || source.href,location.origin);
        target.pathname = target.pathname.match(/.*?\/collections\/[^/]+/)[0] + '/universal'; target.search = ''; target.hash = '';
        const preview = params.get('preview_theme_id'); if (preview) target.searchParams.set('preview_theme_id',preview);
        window.PNMEasyShopping.universalAvailable(target).then(available => {
          if (!available || !panel.isConnected || panel.dataset.signature !== signature) return;
          const note = document.createElement('p'); note.textContent = labels.universalNote;
          const more = document.createElement('a'); more.textContent = labels.universalButton.replace('[category]',category); more.href = target.pathname + target.search;
          panel.insertBefore(note,actions); actions.prepend(more);
        });
      }
    }
  }
  function stopRestoring() {
    if (!restoration) return;
    restoration = null; clearTimeout(restoreTimeout);
    if (oldScrollMode !== null) { history.scrollRestoration = oldScrollMode; oldScrollMode = null; }
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
  }
  function savePosition(event) {
    const link = event.target.closest('a[href]');
    const card = link?.closest(cardSelector);
    if (!link || !card || !card.closest('#gf-grid,#collection-page') || event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ key: collectionKey(location.href), url: location.href, card: card.dataset.productId, top: card.getBoundingClientRect().top, y: scrollY, width: innerWidth, time: Date.now(), focus: link.classList.contains('product-link') ? 'image' : 'title' }));
    } catch (_) {}
  }
  function prepareRestore(persisted = false) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
      const fromProduct = document.referrer && new URL(document.referrer).origin === location.origin && new URL(document.referrer).pathname.includes('/products/');
      if (!saved || Date.now() - saved.time > 1800000 || saved.key !== collectionKey(location.href) || (!persisted && !back && !fromProduct)) return;
      restoration = saved; oldScrollMode = history.scrollRestoration; history.scrollRestoration = 'manual';
      restoreTimeout = setTimeout(() => { if (!busy && restoration) window.scrollTo({ top: restoration.y, behavior: 'instant' }); stopRestoring(); }, 20000);
      restorePosition();
    } catch (_) {}
  }
  function restorePosition() {
    if (!restoration || busy) return;
    const card = [...document.querySelectorAll(':is(#gf-grid,#collection-page) ' + cardSelector)].find(item => item.dataset.productId === restoration.card);
    if (!card || !card.getClientRects().length) return;
    const saved = restoration;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (restoration !== saved || busy || !card.isConnected) return;
      const offset = Math.abs(innerWidth - saved.width) < 40 ? saved.top : 180;
      window.scrollTo({ top: Math.max(0, scrollY + card.getBoundingClientRect().top - offset), behavior: 'instant' });
      const link = card.querySelector(saved.focus === 'image' ? '.product-link' : '.product-title a');
      link?.focus({ preventScroll: true });
      stopRestoring();
    }));
  }
  function sync() {
    queued = false;
    const grid = root();
    if (grid && grid !== observedGrid) {
      observedGrid = grid;
      if (!busy) begin();
      if (cards().length || confirmedEmpty()) settle();
    }
    enhanceUnits(); applyBusy();
    if (busy) {
      const current = cards();
      if (confirmedEmpty() || (current.length && (current.length !== snapshot.length || current.some((card, index) => card !== snapshot[index])))) settle();
    } else { syncEmpty(); restorePosition(); }
  }
  function schedule() { if (!queued) { queued = true; queueMicrotask(sync); } }
  function start() {
    const page = document.querySelector('.page-collections');
    if (!page) return;
    announcement = document.createElement('div'); announcement.className = 'pnm-results-announcement'; announcement.setAttribute('role', 'status'); announcement.setAttribute('aria-live', 'polite'); announcement.setAttribute('aria-atomic', 'true'); page.append(announcement);
    document.addEventListener('click', savePosition, true);
    document.addEventListener('click', event => {
      const target = event.target;
      if (target.closest('#gf-tree [data-filter-id] [role="checkbox"],#globo-dropdown-sort_options [data-sort],#gf_pagination_wrap a,.pnm-filter-chip') && !target.closest('[aria-disabled="true"]')) begin();
    }, true);
    document.addEventListener('submit', event => { if (event.target.closest('.gf-controls-search-form')) begin(); }, true);
    document.addEventListener('change', event => { if (event.target.closest('.gf-filter-selection select')) begin(); }, true);
    window.addEventListener('popstate', () => { begin(); schedule(); });
    window.addEventListener('globoFilterRenderCompleted', () => { enhanceUnits(); settle(); });
    window.addEventListener('pageshow', event => { if (event.persisted) { prepareRestore(true); schedule(); } });
    ['wheel', 'touchstart', 'pointerdown'].forEach(type => window.addEventListener(type, stopRestoring, { passive: true }));
    window.addEventListener('keydown', event => { if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End','Tab',' '].includes(event.key)) stopRestoring(); });
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest('.pnm-card-unit,.pnm-empty-results,.pnm-results-state,.pnm-results-announcement')) return false;
        if (target?.matches('#gf-products,.gf-summary') || target?.closest('.gf-summary')) return true;
        return [...record.addedNodes, ...record.removedNodes].some(item => item.nodeType === 1 && (item.matches('#gf-grid,#gf-products,#gf-controls-container,.gf-summary,.halo-item') || item.querySelector('#gf-grid,#gf-products,.product-card')));
      })) schedule();
    }).observe(page, { childList: true, subtree: true, characterData: true });
    sync(); prepareRestore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
